const breadCrumb = "Diário Digital";

const routes = [
  {
    path: "/calendario-componente",
    name: "calendario-componente",
    meta: {
      allowedPermissions: ["acesso_servidor_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/CalendarioComponente/CalendarioComponenteHome.vue"
      ),
  },
];

export default routes;
